
    var system ={}; 
    var p = navigator.platform;      
    system.win = p.indexOf("Win") == 0; 
    system.mac = p.indexOf("Mac") == 0; 
    system.x11 = (p == "X11") || (p.indexOf("Linux") == 0); 
    var ua = window.navigator.userAgent.toLowerCase(); 
    var osChannel = $.osChannel(); 
    var locatPath = window.location.pathname.toLowerCase();
           

    if(system.win||system.mac||system.xll){
       //pc
    }else{  

     if(osChannel=="android_browser" || osChannel=="ios_browser" || ua.match(/MicroMessenger/i) == 'micromessenger'){
        var cookdown = $.getCookie("downApp");
        if(cookdown =="closed"){
             if(locatPath == "/h5/goods/list/index.html"){
                 $(".page-prdlist").css("top","0")
              }
               $(".downArea").hide();
        }else{

            if(locatPath == "/h5/goods/list/index.html"){
               $(".page-prdlist").css("top","3rem")
            }
            $(".downArea").show();
        }
        
     }else{
       if(locatPath == "/h5/goods/list/index.html"){
                 $(".page-prdlist").css("top","0")
              }
       $(".downArea").hide();
     }
    }
    if(ua.match(/MicroMessenger/i) == 'micromessenger'){
      //微信环境下，根据cookie判断下载引导图是否打开
      var cookwx = $.getCookie("wxApp");
      if(cookwx =="wxclose"){
        $(".pop-share").hide();
      }else{
         $(".pop-share").show();
      }
  }

$('.pop-share .mask').click(function(event) {
   $.setCookie("wxApp","wxclose");
  $(".pop-share").hide();
});

$('.downArea .openDown').click(function(event) {
    //判断如果是微信环境，微信中无法打开立即下载，弹出引导提示图
    if(ua.match(/MicroMessenger/i) == 'micromessenger'){
      $(".pop-share").show();
      return;
    }
     var startTime = new Date()
     if(osChannel=="android_browser"){
        location.href = "gmm://"
       setTimeout(function(){
            var stopTime = new Date()
            if(stopTime - startTime< 1100){ 
                location.href = "https://a.gmm01.com/ud_android_def"
            }           
          },1000)
        
      
     }else if(osChannel=="ios_browser"){
        location.href = "gmmchatios://"
        setTimeout(function(){
          var stopTime = new Date()
          if(stopTime - startTime< 200){ 
              location.href = "https://a.gmm01.com/ud_ios_def"
          }           
        },100)
     }

    
});




$('.downArea .detClose').click(function(event) {
    $(this).parent(".downArea").hide();
     if(locatPath == "/h5/goods/list/index.html" || locatPath == "/h5/goods/detail/index.html"){
          $(".page-prdlist").css("top","0")
        }
     $.setCookie("downApp","closed");
});





Date.prototype.format = function (fmt) { //author: meizz
    var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}


String.prototype.trim=function(){ 
return this.replace(/(^\s*)|(\s*$)/g, ""); 
} 

$.iGetInnerText =function(testStr){
  var resultStr = testStr.replace(/\ +/g, ""); //去掉空格
  resultStr = testStr.replace(/[ ]/g, "");    //去掉空格
  resultStr = testStr.replace(/[\r\n]/g, ""); //去掉回车换行
  return resultStr;
}

$.urlParam = function(name) {
    var results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if(!results) return 0;
    return results[1] || 0;
};
$.urlParamName = function(paramName) {
    var result = location.search.match(new RegExp("[\?\&]" + paramName + "=([^\&]+)", "i"));
    if (result == null || result.length < 1) {
        return "";
    }
    return result[1];
};

var record={num:""};
//校验价格格式
$.checkPrice=function( nowPrice){
    var pricelReg=/^\d{1,7}\.{0,1}\d{0,2}$/;
    var caseprice=nowPrice.val();
    if(caseprice> 9999999){
        nowPrice.val(9999999);
        $.toast("价格输入过大！");
    }
    if (nowPrice.val()!="" && pricelReg.test(nowPrice.val())){
        record.num=""
        record.num=nowPrice.val();
        return true;
    }else {
        if(nowPrice.val()!=""){
            nowPrice.val(record.num);
            /// $.toast("价格格式输入错误！");
            return false;
        }else{
            record.num=""
            return false;
        }
    }

}

var amount={num:""};
//校验数量格式
$.checkAmount=function( nowAmount){
    var pricelReg=/^\d{1,7}\.{0,1}\d{0,2}$/;
    // var pricelReg=/[^\d.]/g;
    var caseprice=nowAmount.val();
    if(caseprice> 9999999){
      nowAmount.val(9999999);
        $.toast("数量输入过大！");
    }
    
    if (nowAmount.val()!="" && pricelReg.test(nowAmount.val())){
      amount.num=""
      amount.num=nowAmount.val();
        return true;
    }else {
        if(nowAmount.val()!=""){
          nowAmount.val(amount.num);
            /// $.toast("价格格式输入错误！");
            return false;
        }else{
          amount.num=""
            return false;
        }
    }
}
$.checkPrice=function(nowAmount,hasLengthLimit){
  var caseprice=nowAmount.val();
  if(caseprice> 9999999){
    nowAmount.val(9999999);
      $.toast("数量或金额输入过大！");
  }
  nowAmount.val(caseprice.replace(/[^\d.]/g,'').replace(/^\./g,'').replace(".","$#$").replace(/\./g,"").replace("$#$",".").replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3'))
  //只允许正数和小数
  //第一个字符只能是数字
  //只能输入一个小数点
  //小数点后最多输入两位小数
}
$.checkNum=function(nowAmount,hasLengthLimit){
  var caseprice=nowAmount.val();
  nowAmount.val(caseprice.replace(/[^\d.]/g,'').replace(/^\./g,'').replace(".","$#$").replace(/\./g,"").replace("$#$",".").replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3'))
  //只允许正数和小数
  //第一个字符只能是数字
  //只能输入一个小数点
  //小数点后最多输入两位小数
}
var Util = 
{
		//G买卖web版本src_code
		SRC_CODE:11,
		//检测当前浏览器是否是ie
		isIE:function ()
		{
			var agent =  navigator.userAgent.toLowerCase();
		    return /msie/.test(agent); 
		},
		//自定义弹框,显示信息or错误
		alert:function(content,title){
			if($("#div_tempmessage").html()){
				//弹框存在时,不能多次弹
			}
			else{
				var html = "";
				if(!title){
					title = "错误!"
					html = "<div id='div_tempmessage' class='popdalg'><h2>"+title+" <a href='javascript:void(0)' onclick='Util.destroy();' class='clomess'></a></h2> <div class='popcon'>"+content+"</div></div>";		
				}
				else{
					html = "<div id='div_tempmessage' class='popdalg'><h1>"+title+" <a href='javascript:void(0)' onclick='Util.destroy();' class='clomess'></a></h1> <div class='popcon'>"+content+"</div></div>";
				}        
				$("body").append(html);
			}
		},
		//关闭弹框
		destroy:function(e){
			$('#div_tempmessage').remove();
            $(".wrapBg").hide();
		},
//计算时间
  formatDuring:function(mss){
    var days = Math.floor(mss / (1000 * 60 * 60 * 24));
    var hours = Math.floor((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((mss % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((mss % (1000 * 60)) / 1000);
    if(days>0){
        return days + "天前" ;
    }else if(hours>0){
          return hours + "小时前" ;
    }else if(minutes>0){
        return  minutes + "分钟前";
    }
  },

  //获取url中query的值
		urlParam:function(name){
			var results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
			if(!results)
			{
				results=0;
			}
			else {
				results=results[1] || 0;
			}

			return results;
		},
		//向cookie中写入值
		setValue:function(name,value){
			document.cookie=name+"="+escape(value);
		},
		//从cookie中取值,无的话返回null
		getValue:function(name){			
			var value = null;
			//读取cookie
			var arrCookie=document.cookie.split(";"); 
			for(var i=0;i<arrCookie.length;i++){ 
				var arr=arrCookie[i].split("="); 
				//找到cookie，并解码然后显示
				var cookieName = arr[0].trim();
				if(cookieName == name){
					value = unescape(arr[1]);
				}
			}			
			return value;
		},
		//按钮发送倒计时
        onSendOver:function(btn){
        	//修改按钮的属性
        	$("#"+btn).attr("sending",true);        	
        	//处理btn倒计时
        	function CountDown(){  
        		if(TIMER>=0){   
	        		$("#"+btn).html("剩余"+TIMER+"秒");
	        		--TIMER;   
        		}   
        		else{   
        			clearInterval(TIMER_ID); 
        			$("#"+btn).html("发送验证码");
        			//修改按钮的属性
        			$("#"+btn).attr("sending","");
        		}   
        	}   
        	var TIMER_ID = setInterval(CountDown,1000);
        	var TIMER = 60;        	
        },
        showPhone:function(){
        	var start = PHONE_NUMBER.substr(0,3);
        	var end = PHONE_NUMBER.substr(7,4);
        	$("#div_mine_phone").html(start+"****"+end);
        },
        //显示错误(不推荐使用)
        onErrorCode:function(code,str){
        	if(code == -777){
        		this.alert("账号已过期,请您重新登录"); 
        		setTimeout(function(){ 
        			//$.ui.loadContent("#login");	
        			//$.ui.hideMask(); 
        		},2000);
        	}
        	else if(code == -50004){

        		this.alert("验证码校验失败!");

        	}
        	else if(code == -20005){
        		this.alert("静态密码阻止,请在叨鱼(原极管家)修改后再上架,步骤如下:1.打开叨鱼(原极管家)；2.账号-账号管理；3.选择对应通行证；4.静态密码锁选择关闭");

        	}
        	else if(code == -41){

        		this.alert("购买失败,您有多笔待付款订单"); 
        		setTimeout(function(){ 
        			//$.ui.loadContent("#havebuy");	
        			//$.ui.hideMask(); 
        		},4000);
        	}
        	else if(code == -53){
        		
        		this.alert("购买失败,您这段时间过期的订单过多，请过一段时间再购买");

        	}
        	else if(code == -30){

        		this.alert("购买失败,该商品已被他人购买");

        	}
        	else if(code == -20002){
        //		this.alert(str);
		 		this.alert("商品购买失败");
				
        	}
        	else{
        		if(str){
        			this.alert(str);        			
        		}        		
        	}
        },
        //显示错误(推荐使用)
        error_notice :function(content,code) {
        	if(code == -777){
        		this.alert("账号已过期,请您重新登录"); 
        	}
        	else if(code == -20005){
        		this.alert("静态密码阻止,请在叨鱼(原极管家)修改后再上架,步骤如下:1.打开叨鱼(原极管家)；2.账号-账号管理；3.选择对应通行证；4.静态密码锁选择关闭");
        	}
        	else if(code == -50009){
        		this.alert("上架失败,填写资料时请不要使用引号,反斜线等'意外'字符!");
        	}
        	else{
        		this.alert(content); 
        	}        	
        },
        //用于上架时json处理
        jsonToString:function(o){
        	//单层json
        	var str="{";
        	var empty = true;
        	for(var i in o){
        		empty = false;
        		str+=encodeURIComponent("\"");
        		str+=encodeURIComponent(i);
        		str+=encodeURIComponent("\"");
        		str+=":";
        		if(isNaN(o[i])){
        			str+=encodeURIComponent("\"");
        		}		
        		str+=encodeURIComponent(o[i]);
        		if(isNaN(o[i])){
        			str+=encodeURIComponent("\"");
        		}		
        		str+=",";
        	}
        	if(!empty){
        		str = str.substr(0,str.length-1);
        	}
        	str+="}";
        	return str;
        },
        jsonInToString:function(o){
        	//两层嵌套json 内层的处理方案
        	var str="{";
        	var empty = true;
        	for(var i in o){
        		empty = false;
        		str+=encodeURIComponent("\\\"");
        		str+=encodeURIComponent(i);
        		str+=encodeURIComponent("\\\"");
        		str+=":";
        		if(isNaN(o[i])){
        			str+=encodeURIComponent("\\\"");
        		}		
        		str+=encodeURIComponent(o[i]);
        		if(isNaN(o[i])){
        			str+=encodeURIComponent("\\\"");
        		}		
        		str+=",";
        	}
        	if(!empty){
        		str = str.substr(0,str.length-1);
        	}        	
        	str+="}";
        	return str;
        },
        parseJob:function(code){
        	var strJobName = "";
            switch (code) {
                case 0:
                  strJobName = "1,11,12,23,24,25,26";
                  break;
                case 1:
                  strJobName = "2,14,15,29,30,31,32";
                  break;
                case 2:
                  strJobName = "3,17,18,35,36,37,38";
                  break;
                case 3:
                    strJobName = "4,20,22,41,42,44,43";
                    break;
                case 4:
                    strJobName = "5,46,49,47,48,50,51";
                    break;
                case 5:
                    strJobName = "6,54,57,55,56,58,59";
                    break;
                case 6:
                    strJobName = "7,62,63,64";
                  break;
              }
            return strJobName;
        },
        getPicNum:function(jobName){
            //默认值0
            var picnum = 0;
            if ("战士" == jobName 
                || "战神"==jobName
              || "剑圣"==jobName 
              || "剑皇"==jobName
              || "月之领主"==jobName 
              || "毁灭者"==jobName
              || "狂战士"==jobName
              ) 
            {
              picnum = 1;
          } 
            else if ("弓箭手"==jobName 
                || "箭神"==jobName
              || "游侠"==jobName 
              || "狙翎"==jobName
              || "魔羽"==jobName 
              || "影舞者"==jobName
              || "风行者"==jobName
              ) 
            {
              picnum = 2;
          }
            else if ("魔法师"==jobName 
                || "元素师"==jobName
              || "魔导师"==jobName 
              || "火舞"==jobName
              || "冰灵"==jobName 
              || "时空领主"==jobName
              || "黑暗女王"==jobName
              ) 
            {
              picnum = 3;
          } 
            else if ("牧师"==jobName 
                || "贤者"==jobName
              || "祭司"==jobName 
              || "圣骑士"==jobName
              || "十字军"==jobName 
              || "雷神"==jobName
              || "圣徒"==jobName
              ) 
            {
              picnum = 4;
          } 
            else if ("学者"==jobName 
                || "工程师"==jobName
              || "炼金术士"==jobName 
              || "重炮手"==jobName
              || "机械大师"==jobName 
              || "炼金圣士"==jobName
              || "药剂师"==jobName
              ) 
            {
              picnum = 5;
          } 
            else if ("舞娘"==jobName 
                || "呐喊者"==jobName
              || "舞者"==jobName 
              || "黑暗萨满"==jobName
              || "噬魂者"==jobName 
              || "刀锋舞者"==jobName
              || "灵魂舞者"==jobName
              ) 
            {
              picnum = 6;
          } 
            else if ("刺客"==jobName 
                || "暗之使徒"==jobName
              || "烈"==jobName 
              || "影"==jobName
              ) 
            {
              picnum = 7;
          }
            return picnum;
          },
          getJobName:function(jobnum){


            var strJobName = "未知职业";
            switch (jobnum) {
                case 1:
                  strJobName = "战士";
                  break;
                case 2:
                  strJobName = "弓箭手";
                  break;
                case 3:
                  strJobName = "魔法师";
                  break;
                case 4:
                  strJobName = "牧师";
                  break;
                case 5:
                  strJobName = "学者";
                  break;
                case 6:
                  strJobName = "舞娘";
                  break;
                case 7:
                  strJobName = "刺客";
                  break;
                case 10:
                  strJobName = "古代人";
                  break;
                case 11:
                  strJobName = "剑圣";
                  break;
                case 12:
                  strJobName = "战神";
                  break;
                case 13:
                  strJobName = "复仇者";
                  break;
                case 14:
                  strJobName = "箭神";
                  break;
                case 15:
                  strJobName = "游侠";
                  break;
                case 16:
                  strJobName = "猎人";
                  break;
                case 17:
                  strJobName = "元素师";
                  break;
                case 18:
                  strJobName = "魔导师";
                  break;
                case 19:
                  strJobName = "术士";
                  break;
                case 20:
                  strJobName = "贤者";
                  break;
                case 21:
                  strJobName = "僧侣";
                  break;
                case 22:
                  strJobName = "祭司";
                  break;
                case 23:
                  strJobName = "剑皇";
                  break;
                case 24:
                  strJobName = "月之领主";
                  break;
                case 25:
                  strJobName = "狂战士";
                  break;
                case 26:
                  strJobName = "毁灭者";
                  break;
                case 29:
                  strJobName = "狙翎";
                  break;
                case 30:
                  strJobName = "魔羽";
                  break;
                case 31:
                  strJobName = "影舞者";
                  break;
                case 32:
                  strJobName = "风行者";
                  break;
                case 35:
                  strJobName = "火舞";
                  break;
                case 36:
                  strJobName = "冰灵";
                  break;
                case 37:
                  strJobName = "时空领主";
                  break;
                case 38:
                  strJobName = "黑暗女王";
                  break;
                case 41:
                  strJobName = "圣骑士";
                  break;
                case 42:
                  strJobName = "十字军";
                  break;
                case 43:
                  strJobName = "圣徒";
                  break;
                case 44:
                  strJobName = "雷神";
                  break;
                case 45:
                  strJobName = "驱魔师";
                  break;
                case 46:
                  strJobName = "工程师";
                  break;
                case 47:
                  strJobName = "重炮手";
                  break;
                case 48:
                  strJobName = "机械大师";
                  break;
                case 49:
                  strJobName = "炼金术士";
                  break;
                case 50:
                  strJobName = "炼金圣士";
                  break;
                case 51:
                  strJobName = "药剂师";
                  break;
                case 52:
                  strJobName = "";
                  break;
                case 53:
                  strJobName = "";
                  break;
                case 54:
                  strJobName = "呐喊者";
                  break;
                case 55:
                  strJobName = "黑暗萨满";
                  break;
                case 56:
                  strJobName = "噬魂者";
                  break;
                case 57:
                  strJobName = "舞者";
                  break;
                case 58:
                  strJobName = "刀锋舞者";
                  break;
                case 59:
                  strJobName = "灵魂舞者";
                  break;
                case 60:
                  strJobName = "";
                  break;
                case 61:
                  strJobName = "";
                  break;
                case 62:
                  strJobName = "暗之使徒";
                  break;
                case 63:
                  strJobName = "烈";
                  break;
                case 64:
                  strJobName = "影";
                  break;
              }
            return strJobName;
          },
          getBuyerOrderStatus:function(status) {
      		var strStatus = "未知状态";
      		status = Number(status);
      		switch (status) {
      		case 1:
      			strStatus = "待付款";
      			break;
      		case 2:
      			strStatus = "付款成功";//1
      			break;
      		case 3:
      			strStatus = "已发货";
      			break;
      		case 4:
      			strStatus = "交易失败，退款中";
      			break;
      		case 5:
      			strStatus = "已过期";
      			break;
      		case 6:
      			strStatus = "交易失败";
      			break;
      		case 7:
      			strStatus = "交易成功";
      			break;
      		case 8:
      			strStatus = "已退款";
      			break;
      		case 9:
      			strStatus = "付款确认中";
      			break;
      		case 10:
      			strStatus = "已取消";
      			break;
      		case 11:
      			strStatus = "处理中";
      			break;
      		case 13:
      			strStatus = "已预订，待发货";
      			break;
      		case 16:
      			strStatus = "待确认购买";//1
      			break;
      		case 17:
      			strStatus = "退款中";
      			break;
      		case 18:
      			strStatus = "交易完成";//3
      			break;
      		case 19:
      			strStatus = "待过户";//2
      			break;

      		default:
      			strStatus += status;
      		}
      		return strStatus;
      	},
      	getSellerOrderStatus:function(status,update_time) {
      		
      		
      		status = Number(status);
    		var strStatus = "未知状态";
    		switch (status) {
    		case 1:
    			strStatus = "未付款";
    			break;
    		case 2:
    			strStatus = "付款成功";
    			break;
    		case 3:
    			strStatus = "已发货，3天后收款";
    			break;
    		case 4:
    			strStatus = "交易失败，已退款";
    			break;
    		case 5:
    			strStatus = "交易失败";
    			break;
    		case 6:
    			strStatus = "交易失败";
    			break;
    		case 7:
    			strStatus = "交易成功";
    			break;
    		case 8:
    			strStatus = "交易失败";
    			break;
    		case 9:
    			strStatus = "交易中";
    			break;
    		case 10:
    			strStatus = "已取消";
    			break;
    		case 11:
    			strStatus = "交易中";
    			break;
    		case 13:
    			strStatus = "已预订，待发货";
    			break;
    		case 16:
    			strStatus = "交易中";
    			break;
    		case 17:
    			strStatus = "交易中";
    			break;
    		case 18:
    			strStatus = "待收款";
    			break;
    		case 19: {
//    			SimpleDateFormat formatDate = new SimpleDateFormat(
//    					"yyyy-MM-dd HH:mm:ss");
//    			Date updateTime;
//    			try {
//    				updateTime = formatDate.parse(update_time);
//    			} catch (Exception e) {
//    				return "待收款";
//    			}
//    			long deadLine = updateTime.getTime() + 3 * 24 * 3600 * 1000;
//    			long now = new Date().getTime();
//    			if (deadLine > now) {
//    				strStatus = "待收款";
//    			} else {
//    				strStatus = "交易成功";
//    			}
//    			break;
    			
    			strStatus = "待收款/交易成功";
    			break;
    		}
    			

    		default:
    			strStatus += String.valueOf(status);
    		}
    		return strStatus;
    	},
    	getAccountStatus:function(status) {
      		var strStatus = "未知状态";
      		status = parseInt(status);
      		switch (status) {
      		case -2:
      			strStatus = "上架失败";
      			break;
      		case -1:
      			strStatus = "预上架失败";
      			break;
      		case 0:
      			strStatus = "等待上架";
      			break;
      		case 1:
      			strStatus = "公示期中";
      			break;
      		case 2:
      			strStatus = "出售中";
      			break;
      		case 3:
      			strStatus = "已下架";
      			break;
      		case 4:
      			strStatus = "已出售";
      			break;
      		case 5:
      			strStatus = "已预定";
      			break;
      		case 6:
      			strStatus = "公示期中锁定";
      			break;
      		case 7:
      			strStatus = "出售中锁定";
      			break;
      		case 8:
      			strStatus = "待审核状态";
      			break;
      		case 9:
      			strStatus = "审核未通过状态";
      			break;
      		default:
      			strStatus += status;
      		}
      		return strStatus;
      	},
      	getSellState:function(status) {
      		var strStatus = "";
      		status = Number(status);
      		switch (status) {
      		case 0:
      			strStatus = "<em>（可售）</em>";
      			break;
      		case 1:
      			strStatus = "<span>（公示中）</span>";
      			break;
      		case 2:
      			strStatus = "<span>（出售中）</span>";
      			break;
      		case 7:
      			strStatus = "<span>（出售中,已锁定）</span>";
      			break;
      		case 8:
      			strStatus = "<span>（出售中,待审核）</span>";
      			break;
      		}
      		return strStatus;
      	},
      	addNull:function(list,num){
        	for(var i = 0;i<num-1;i++){
        		
        		var item = {};
        		item.visibility = "hidden";
        		list.push(item);
        		
        	}
        },
        formatNumber: function (num, pattern) {
        /**
         * 格式化数字显示方式
         * 用法
         * formatNumber(12345.999,'#,##0.00');
         * formatNumber(12345.999,'#,##0.##');
         * formatNumber(123,'000000');
         * @param num
         * @param pattern
         */
        var strarr = num ? num.toString().split('.') : ['0'];
        var fmtarr = pattern ? pattern.split('.') : [''];
        var retstr = '';
        // 整数部分
        var str = strarr[0];
        var fmt = fmtarr[0];
        var i = str.length - 1;
        var comma = false;
        for (var f = fmt.length - 1; f >= 0; f--) {
            switch (fmt.substr(f, 1)) {
                case '#':
                    if (i >= 0) retstr = str.substr(i--, 1) + retstr;
                    break;
                case '0':
                    if (i >= 0) retstr = str.substr(i--, 1) + retstr;
                    else retstr = '0' + retstr;
                    break;
                case ',':
                    comma = true;
                    retstr = ',' + retstr;
                    break;
            }
        }
        if (i >= 0) {
            if (comma) {
                var l = str.length;
                for (; i >= 0; i--) {
                    retstr = str.substr(i, 1) + retstr;
                    if (i > 0 && ((l - i) % 3) == 0) retstr = ',' + retstr;
                }
            }
            else retstr = str.substr(0, i + 1) + retstr;
        }

        retstr = retstr + '.';
        // 处理小数部分
        str = strarr.length > 1 ? strarr[1] : '';
        fmt = fmtarr.length > 1 ? fmtarr[1] : '';
        i = 0;
        for (var f = 0; f < fmt.length; f++) {
            switch (fmt.substr(f, 1)) {
                case '#':
                    if (i < str.length) retstr += str.substr(i++, 1);
                    break;
                case '0':
                    if (i < str.length) retstr += str.substr(i++, 1);
                    else retstr += '0';
                    break;
            }
        }
        return retstr.replace(/^,+/, '').replace(/\.$/, '');
    }

	};
